export const SPEEDS = {
  SLOWEST: 700,
  SLOWER: 600,
  SLOW: 500,
  DEFAULT: 400,
  FAST: 300,
  FASTER: 200,
  FASTEST: 100,
} as const;
